import { Outlet } from 'react-router-dom'
import RouteSuspense from '../components/RouteSuspense'
import { useOrgAuth } from '../contexts/OrgAuthContext'
import AnalyticsTracker from '../components/AnalyticsTracker'
import AuthGuard from '../components/AuthGuard'
import { AppLayout } from '../components/layout/AppLayout'

export default function OrgAppShell() {
  const { session, isLoading } = useOrgAuth()

  return (
    <AuthGuard isLoading={isLoading} isAuthenticated={!!session}>
      <AppLayout>
        <AnalyticsTracker />
        <RouteSuspense><Outlet /></RouteSuspense>
      </AppLayout>
    </AuthGuard>
  )
}
